<template>
    <b-row>
        <b-col sm="3" class="mt-3">
            <label for="">Sucursal</label>
            <select class="form-control form-control-sm" v-model="sucursal" @change="limpiar_lista">
                <option value="">Seleccionar</option>
                <option v-for="(item, index) in SUCURSALES_SIN_BODEGA_CENTRAL" :key="index" :value="item.codigo">{{
                    item.nombre }}</option>
            </select>
        </b-col>

        <b-col sm="3" class="mt-3">
            <label for="">Usuario</label>
            <select class="form-control form-control-sm" v-model="usuario__" @change="limpiar_lista">
                <option value="">Seleccionar</option>
                <option v-for="(item, index) in usuarios" :key="index" :value="item.id_usuario">{{ item.nombre_completo
                }}
                </option>
            </select>
        </b-col>

        <b-col sm="2" class="mt-3">
            <label for="">Fecha inicial</label>
            <b-form-input type="date" size="sm" v-model="fecha_inicial"></b-form-input>
        </b-col>

        <b-col sm="2" class="mt-3">
            <label for="">Fecha final</label>
            <b-form-input type="date" size="sm" v-model="fecha_final"></b-form-input>
        </b-col>

        <b-col sm="2" class="mt-5">
            <b-button block type="button" variant="info" size="sm" @click="buscar">Buscar</b-button>
        </b-col>

        <b-col sm="12" class="mt-3">
            <table class="table table-sm table-striped table-bordered" style="font-size: 14px;">
                <thead>
                    <tr>
                        <th style="width: 50%;">
                            Origen
                        </th>
                        <th style="width: 50%;text-align: center;">
                            Valores
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            Número de facturas de pago con efectivo
                        </td>
                        <td style="text-align: center;">
                            {{ resultados.registros_efectivo }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Número de facturas de pago con tarjeta
                        </td>
                        <td style="text-align: center;">
                            {{ resultados.registros_tarjeta }}
                        </td>
                    </tr>

                    <tr>
                        <td>
                            Número de facturas con pago en efectivo y tarjeta
                        </td>
                        <td style="text-align: center;">
                            {{ resultados.registros_ambos }}
                        </td>
                    </tr>

                    <tr>
                        <td>
                            Total facturas
                        </td>
                        <td style="text-align: center;">
                            {{ resultados.total_facturas }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Total Efectivo
                        </td>
                        <td style="text-align: center;">
                            Q{{ this.total_efectivo.toLocaleString(undefined, {
                                minimumFractionDigits: 2, maximumFractionDigits: 2
                            }) }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Total Tarjeta
                        </td>
                        <td style="text-align: center;">
                            Q{{ this.total_tarjeta.toLocaleString(undefined, {
                                minimumFractionDigits: 2, maximumFractionDigits: 2
                            }) }}
                        </td>
                    </tr>
                    <tr style="background-color: black;color: white">
                        <td style="text-align: right;">
                            Total de movimientos
                        </td>
                        <td style="text-align: center;">
                            Q{{ (this.total_efectivo + this.total_tarjeta).toLocaleString(undefined, {
                                minimumFractionDigits: 2, maximumFractionDigits: 2
                            }) }}
                        </td>
                    </tr>
                    <tr style="background-color: black;color: white">
                        <td style="text-align: right;">
                            Total a depositar
                        </td>
                        <td style="text-align: center;">
                            Q{{ this.total_deposito.toLocaleString(
                                undefined, {
                                minimumFractionDigits: 2, maximumFractionDigits: 2
                            }
                            ) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </b-col>
    </b-row>
</template>

<script>
    import { minix } from '@/components/functions/alertas';
    import moment from 'moment';
    import { mapActions, mapGetters, mapState } from 'vuex';

    export default {
        name: 'CorteDeCaja',
        computed: {
            ...mapState(['id_empresa_seleccionada']),
            ...mapGetters(['SUCURSALES_SIN_BODEGA_CENTRAL'])
        },
        data() {
            return {
                sucursal: '',
                usuario__: '',
                usuarios: [],
                fecha_inicial: moment(Date.now()).format('YYYY-MM-DD'),
                fecha_final: moment(Date.now()).format('YYYY-MM-DD'),
                datos_corte: {},
                resultados: {},
                total_efectivo: 0,
                total_tarjeta: 0,
                total_deposito: 0
            }
        },
        methods: {
            async obtener_usuarios_por_sucursal() {
                if (this.sucursal != '') {

                    let f = {
                        api: `usuario-empresas/c/usuario-por-sucursal?empresa=${this.id_empresa_seleccionada}&sucursal=${this.sucursal}`
                    }

                    let r = await this.obtener_data(f)
                    if (r.length == 0) {
                        minix({ icon: 'info', mensaje: 'No usuarios asignados a esta sucursal', tiempo: 3000 })
                        this.usuarios = []
                        this.usuario__ = ''
                        return
                    } else {
                        this.usuarios = r
                    }

                } else {
                    this.usuarios = []
                }
            },
            async buscar() {
                if (this.sucursal == '' || this.usuario__ == '') {
                    minix({ icon: 'error', mensaje: 'Selecciona una sucursal y un usuario', tiempo: 3000 })
                } else {

                    // let f = {
                    //     api: `movimientos-cabeceras/c/corte_de_caja_admin`,
                    //     formulario: {
                    //         fecha_inicial: this.fecha_inicial,
                    //         fecha_final: this.fecha_final,
                    //         sucursal: this.sucursal,
                    //         usuario: this.usuario__
                    //     }
                    // }

                    // let r = await this.guardar_data(f)

                    // this.datos_corte = r

                    let f = {
                        api: `movimientos-cabeceras/r/reporte-corte-caja-por-vendedor?fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}&empresa=${this.id_empresa_seleccionada}&sucursal=${this.sucursal}&vendedor=${this.usuario__}`
                    }

                    let r = await this.obtener_data(f)

                    this.resultados = r
                    this.total_efectivo = r.total_efectivo
                    this.total_tarjeta = r.total_tarjeta
                    this.total_deposito = r.total_efectivo
                }
            },
            limpiar_lista() { },
            ...mapActions(['obtener_data', 'guardar_data'])
        },
        watch: {
            sucursal() {
                this.obtener_usuarios_por_sucursal()
            }
        }
    }
</script>

<style></style>